export const CAPABILITY_DOC_URL =
  "https://customer-assets.emergentagent.com/job_9667ec6b-0657-4356-9847-b332bf6ecbd8/artifacts/tnf7pe56_Frontiers%20Infra%20Sustainability%20Consortium.pdf";

export const NAV_LINKS = [
  { label: "About", href: "#about" },
  { label: "What We Do", href: "#services" },
  { label: "Why Us", href: "#why-us" },
  { label: "Partners", href: "#partners" },
  { label: "Delivery", href: "#delivery" },
  { label: "Projects", href: "#projects" },
];

export const SERVICES = [
  {
    icon: "Leaf",
    title: "Integrated Sustainability Planning",
    desc: "Coordinated sustainability strategy for townships, industrial clusters, campuses, civic assets, and infrastructure projects.",
  },
  {
    icon: "Trees",
    title: "Landscape Design & Development",
    desc: "Public realm, green zones, ecological systems, and climate-sensitive placemaking for user-oriented environments.",
  },
  {
    icon: "Target",
    title: "ESG, Net-Zero & Certification",
    desc: "Carbon reduction, certification strategy, and long-term asset performance aligned to net-zero pathways.",
  },
  {
    icon: "Zap",
    title: "Renewable Energy & Microgrids",
    desc: "Renewable integration, microgrid and energy-efficiency solutions for commercial, industrial and utility-scale assets.",
  },
  {
    icon: "Lightbulb",
    title: "Architectural & Public-Realm Lighting",
    desc: "Indoor, outdoor, landscape, industrial, and architectural lighting across every environment.",
  },
  {
    icon: "Sun",
    title: "Solar Street & Common-Area Lighting",
    desc: "Solar street lighting and solar-powered common-area lighting for resilient, low-OPEX public spaces.",
  },
  {
    icon: "Wifi",
    title: "Smart Lighting & Controls",
    desc: "Dimming, wireless control, app-based management, and connected lighting ecosystems.",
  },
  {
    icon: "Activity",
    title: "Industrial IoT, SCADA & Analytics",
    desc: "Asset monitoring, dashboarding, analytics and performance reporting for measurable operational visibility.",
  },
];

export const WHY_US = [
  "One integrated consortium instead of fragmented consultants and vendors.",
  "Practical sustainability that can be designed, implemented, measured, and optimized over time.",
  "Better lifecycle OPEX, resilience, ESG credibility, and operating efficiency.",
  "Coordination across planning, design, energy, lighting, digital monitoring, and post-project optimization.",
  "A scalable model for complex projects requiring both strategy and implementation support.",
];

export const PARTNERS = [
  {
    name: "Frontiers Infra Sustainability Consortium",
    role: "Integrated Platform",
    desc: "The client-facing platform coordinating the full consortium model into one delivery framework.",
  },
  {
    name: "Frontiers Design Syndicate Pvt Ltd",
    role: "Landscape & Placemaking",
    desc: "Landscape design, placemaking, public realm, ecological features, and green-township interventions.",
  },
  {
    name: "Sustainability Consulting Capability",
    role: "Advisory & Strategy",
    desc: "Energy, water, waste, carbon, resilience, certifications, biodiversity, mobility, and governance-linked improvement.",
  },
  {
    name: "CES NeoSilica",
    role: "Energy & Digital",
    desc: "Renewable energy, microgrids, energy-efficiency, monitoring, analytics, and digital performance systems.",
  },
  {
    name: "WIIZ Lights & Electricals LLP",
    role: "Lighting Systems",
    desc: "Architectural, industrial, public-realm, landscape, solar street lighting, and smart lighting ecosystems.",
  },
];

export const DELIVERY = [
  {
    stage: "01",
    title: "Pre-Project",
    items: [
      "Sustainability assessment and gap analysis",
      "Design review, value engineering, and technical inputs",
      "Landscape and public realm strategy",
      "Lighting strategy and common-area solar lighting planning",
      "Budget alignment and implementation roadmap",
    ],
  },
  {
    stage: "02",
    title: "Project Phase",
    items: [
      "Baselining, benchmarking, and target setting",
      "Procurement and RFP support",
      "Renewable integration and digital monitoring setup",
      "Lighting integration across all systems",
      "Monitoring, analytics, reporting, and coordination",
    ],
  },
  {
    stage: "03",
    title: "Post-Project",
    items: [
      "Sustainability disclosures and reporting support",
      "ESG-oriented stakeholder communication",
      "Operational optimization and performance handholding",
      "Continuous improvement pathways",
      "Lighting and systems optimization for lifecycle performance",
    ],
  },
];

export const BEST_FIT = [
  "Green townships and integrated urban developments",
  "Industrial parks and manufacturing campuses",
  "Civic infrastructure and public-realm programs",
  "Commercial campuses and institutional facilities",
  "Streetscape, landscape, and common-area projects",
  "ESG-led, net-zero infrastructure and real estate",
];

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1451976426598-a7593bd6d0b2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwzfHxzdXN0YWluYWJsZSUyMG1vZGVybiUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3ODM2OTMxNzB8MA&ixlib=rb-4.1.0&q=85",
  solar: "https://images.unsplash.com/photo-1508514177221-188b1cf16e9d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwxfHxzb2xhciUyMGVuZXJneSUyMGluZnJhc3RydWN0dXJlfGVufDB8fHx8MTc4MzY5MzE3MHww&ixlib=rb-4.1.0&q=85",
  about: "https://images.unsplash.com/photo-1569227997603-33b9f12af927?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwyfHxzdXN0YWluYWJsZSUyMG1vZGVybiUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3ODM2OTMxNzB8MA&ixlib=rb-4.1.0&q=85",
};
